<script setup>
import { onMounted, ref } from "vue";
import { useSettingsStore } from "@/stores/storeSettings";
import { useScrollStore } from "@/stores/storeScroll";
import { useModals } from "@/composables/useModals";
import { policyUrl, rulesUrl, agreementUrl } from "@/utils/provider";
import { sendMetrik } from "@/utils/metrika";
import { sendAdriver } from "@/utils/metrika";

const { openModal } = useModals();

const storeSettings = useSettingsStore();
const storeScroll = useScrollStore();

const footerRef = ref(null);

onMounted(async () => {
	storeScroll.footer = footerRef.value;
});
</script>
<template>
	<footer class="footer" ref="footerRef" id="footer">
		<div class="container --big">
			<div class="footer__container">
				<div class="footer__top">
					<!-- <RouterLink v-if="!storeSettings.isTelegramPage" to="/" class="logo">
						<img width="284" height="139" src="@/assets/img/icons/logo.svg" alt="Greenfield" class="logo__img" />
					</RouterLink>
					<div v-else class="logo">
						<img width="284" height="139" src="@/assets/img/icons/logo.svg" alt="Greenfield" class="logo__img" />
					</div> -->
					<nav class="footer__nav">
						<a @click="(sendAdriver('rules_click'), sendMetrik('reachGoal', 'Rules_Click'))" target="_blank" rel="noopener noreferrer" :href="rulesUrl">Правила акции</a>
						<a target="_blank" rel="noopener noreferrer" :href="policyUrl">Политика конфиденциальности</a>
					</nav>
					<button v-if="!storeSettings.isTelegramPage" class="footer__btn btn --small" @click="openModal('feedback'), sendMetrik('reachGoal', 'click_ask_question')">задать вопрос</button>
				</div>
				<p class="footer__text">
					Для участия в акции необходимо: в период с 05 февраля 2026 г. по 20 декабря 2026 г. приобрести в любом магазине на территории РФ любую упаковку чая Greenfield ®, зарегистрировать чек с покупкой на сайте www.greenfield-club.ru или в чат-боте @greenfieldworld_bot, накопить «листочки» (каждый 1 рубль
					равняется 1 «листочку») и обменять их на доступные подарки, участвовать в розыгрыше призов. Общий срок проведения акции (включая срок выдачи подарков): с 05 февраля 2026 г. по 31 декабря 2026 г. Количество призов и подарков ограничено. Призы и подарки могут отличаться от изображений на рекламных
					материалах. Информация об организаторе акции, сроках и правилах ее проведения, количестве подарков, сроках, месте и порядке их вручения размещена на сайте www.greenfield-club.ru. Организатор акции — ООО «Эктив Проджект Менеджмент» (ООО «АРМ»), ИНН 7705609429.
				</p>
			</div>
		</div>
	</footer>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";

.footer {
	position: relative;
	padding: 0rem 0 5.1rem;
	padding: 4rem 0 5.1rem;
	border-top: 1px solid rgba(14, 14, 14, 0.16);
	z-index: 1;
	@media (max-width: vars.$x480) {
		padding: 0rem 0 2rem;
		padding: 2rem 0 2rem;
	}

	&__btn {
		font-size: 2rem;
		min-height: 4.8rem;
	}
}
.footer__top {
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 1rem;
	margin-bottom: 5.5rem;
	@media (max-width: vars.$t) {
		flex-direction: column;
		gap: 1.8rem;
		margin-bottom: 2.7rem;
	}
}
.footer__container {
	padding-right: 2.5rem;
	@media (max-width: vars.$l) {
		padding-right: 0;
	}
}

.logo {
	@media (max-width: vars.$x480) {
		width: 18.5rem;
	}
}

.footer__nav {
	display: flex;
	align-items: center;
	gap: 3rem;
	@media (max-width: vars.$t) {
		flex-direction: column;
		gap: 1.2rem;
	}
	@media (max-width: vars.$x480) {
		gap: 0;
	}
	a {
		font-weight: 600;
		font-size: 2rem;
		line-height: 120%;
		color: var(--text-inverse-100);
		border-radius: 10rem;
		padding: 0.6rem 1.8rem;
		border: 1px solid transparent;
		@media (hover: hover) {
			&:hover {
				border-color: currentColor;
			}
		}
		@media (max-width: vars.$xx) {
			padding: 0.6rem 1rem;
			font-size: 1.6rem;
		}
	}
}
.footer__text {
	font-weight: 400;
	font-size: 1.4rem;
	line-height: 140%;
	color: var(--text-inverse-100);
	@media (max-width: vars.$t) {
		// text-align: center;
	}
	@media (max-width: vars.$x480) {
		font-size: 1.2rem;
	}
}
</style>
